export const getRelatedApps = (state: AnyFixMe) => state.relatedApps.value;
